import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { Button, Card, CardBody, CardFooter, CardHeader, Col, Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import { SessionModel } from '../../models/SessionModel';
import { ApplicationState } from '../../store';
import { ServiceContactList, ServiceContactModel, initialState as NewContact } from '../../models/ServiceContactModel';
import * as ServContStore from '../../store/ServiceContact';
import { LoadingIcon } from '../Misc/Loading';
import { SaCurrency, SaDate, SaLabel, SaPhone } from '../Misc/SawinComponents';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as FontAwesomeIcons from '@fortawesome/free-solid-svg-icons';

type MyProps =
    { ServiceContactList: ServiceContactList } & { SessionState: SessionModel } & typeof ServContStore.actionCreators;

class ServiceContactScreen extends React.PureComponent<MyProps> {

    componentDidMount() {
        this.props.loadServiceContact();        
    }
    
    public render() {
        
        return (
            <Container fluid={true}>
                <LoadingIcon loading={this.props.ServiceContactList.loading} title={this.props.SessionState.SelectedSM.id + " - " + this.props.SessionState.SelectedSM.name.displayName} address={this.props.SessionState.SelectedSM.address} />
                <div className="center-align">
                <Link to={{ pathname: '/ContactEntry', state: NewContact }} >
                        <Button className='top-screen-button'>New Contact</Button>
                    </Link>
                    </div>
                
                        
                    {this.props.ServiceContactList.items.map((item, index) =>
                        <Row key={index}>
                            <ServiceContactCard item={item} parentProps={this.props} companyCode={this.props.SessionState.SelectedAR.companyCode} ></ServiceContactCard>
                        </Row>
                    )}                
            </Container>
        );
    }
}

class ServiceContactCard extends React.PureComponent<{ item: ServiceContactModel, companyCode: string, parentProps: MyProps }> {
    
    public render() {

        const clickHandler = (e: React.MouseEvent) => {            
            this.props.parentProps.deleteServiceContact(this.props.item.sequence);
        }
 
        return (<Card className='service-contact-card'>
            <CardHeader>
                <Row>
                    <Col xs="9"> 
                        {this.props.item.contactName}
                    </Col> 
                    <Col xs="3" className="right-align">
                        <span>
                        <Link to={{ pathname: '/ContactEntry', state: this.props.item }} >
                            <FontAwesomeIcon icon={FontAwesomeIcons.faPencilAlt} className="miscBackIcon" />      
                            </Link>
                        </span>
                        <span style={{ marginLeft: "15px" }}><FontAwesomeIcon icon={FontAwesomeIcons.faTrashAlt} className="miscBackIcon" onClick={clickHandler} />
                        </span>
                    </Col>
                </Row>
            </CardHeader>
            <CardBody>
                <Row>
                    <Col>
                        <SaLabel Text={"Phone"} />
                        <SaPhone UnformattedPhone={this.props.item.phoneNumber} />
                    </Col>
                    <Col>
                        <SaLabel Text={"Work"} />  <SaPhone UnformattedPhone={this.props.item.workPhoneNumber} />
                        {this.props.item.phoneExt && <SaLabel InLine={true} Text={" x."} />}  {this.props.item.phoneExt} 
                    </Col>
                </Row>
                <Row>
                <Col>
                        <SaLabel Text={"Personal Cell"} />  <SaPhone UnformattedPhone={this.props.item.mobilNumber} />
                </Col>
                    <Col>
                            <SaLabel Text={"Work Cell"} />  <SaPhone UnformattedPhone={this.props.item.workMobileNumber}  />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <SaLabel Text={"Email"} />  {this.props.item.email}
                    </Col>                    
                </Row>                
            </CardBody>            
        </Card>);
    }
}

export default connect(
    (state: ApplicationState) => ({ ...{ ServiceContactList: state.serviceContactState }, ...{ SessionState: state.sessionState } }),
    ServContStore.actionCreators)(ServiceContactScreen as any);
